export enum PropertyTitle {
  UNSET,
  FEE_SIMPLE,
  LEASEHOLD,
}
